export default "__VITE_ASSET__Bg6Uh8_X__"